<template>
  <div id='appbind' class=''>
    
    <div class='gPageBorder'>
      <div style='width:140px;height:140px;margin:24px 24px 24px 24px;display:inline-block;float:left;overflow:hidden;'>
        <!-- <img style='width:100%;' :src="avt"> -->
        <div :style='avtStyle'></div>
      </div><div style='display:inline-block;width:calc(100% - 188px);height:100%;margin-bottom:0px;:'>
        <div style='height:64px;'>
          <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{info ? info.appName : ''}}</button>
        </div>
        <div style='height:60px;'>
          <table class='dt-app'>
            <tr>
              <td>
                <label class='dt-word-title'>{{$t('app_version')}}：</label>
                <label class='dt-word-main'>{{info? info.appVersion : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_verTag')}}：</label>
                <label class='dt-word-main'>{{info? info.versioncode : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_package')}}：</label>
                <label class='dt-word-main'>{{info? info.packagename : ''}}</label>
              </td>
            </tr>
            <tr>
              <td>
                <label class='dt-word-title'>{{$t('app_appType')}}：</label>
                <label class='dt-word-main'>{{info? info.appCategoryName : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_insType')}}：</label>
                <label class='dt-word-main'>{{setInstallType(info.appInstallType)}}</label>
              </td>
              <td></td>
            </tr>
          </table>
        </div>
        <div style='min-height:60px;display:flex;display:-webkit-flex;'>
          <div class='dt-word-title' style='display:inline-block;min-width:70px;'>
            {{$t('app_introl')}}：
          </div>
          <div class='dt-word-main' style='display:inline-block;position:relative;padding: 0 24px 24px 0px;'>
            <pre>{{info? info.appDesc : ''}}</pre>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id='abInfo'>
      <div style='width:120px;background:none;'>
        <img style='width:72px;height:72px;margin:16px 0 0 24px;' :src='avt'>
      </div>
      <div style='background:none;flex:1;display:flex;display:-webkit-flex;flex-direction:column;'>
        <div style='height:32px;background:none;display:flex;display:-webkit-flex;align-items:flex-end;'>
          <label style='font-size:14px;color:#5E6D82;'>{{$t('app_baseInfo')}}</label>
        </div>
        <div style='background:none;flex:1;display:flex;display:-webkit-flex;align-items:center'>
          <div class='diTag'>
            <div>
                <div>{{$t('app_appName')}}：{{info.appName}}</div>
                
                <div>{{$t('app_fileSize')}}：{{(info.appSize / 1000000).toFixed(2)}}M</div>
            </div>
          </div><div class='diTag'>
            <div>
              <div>{{$t('app_type')}}：{{info.appCategoryName}}</div>
              
              <div>{{$t('app_insType')}}：{{setInstallType(info.appInstallType)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div id='' class='gPageBorder gTopMg'>
      <p class='gCtColor gPTitle' style=''>{{$t('app_pushDevice')}}</p>

      <el-button class='gSgLeftBtn' @click='addBind'>{{$t('app_addPush')}}</el-button>

      <el-button @click='allUnbind()' style=''>{{$t('app_mulUnbind')}} ({{sNum}})</el-button>

      
     
      <el-table
      class='gTopMg'
      ref="multipleTable"
      id='dpTable'
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          align='center'
          width="55">
        </el-table-column>
        <el-table-column
          prop="terminalName"
          align='center'
          :label="$t('app_deviceName')"
          width="">
        </el-table-column>
        <el-table-column
          align='center'
          prop="terminalNo"
          :label="$t('app_deviceNo')"
          width="">
        </el-table-column>
        <el-table-column
          prop="createTime"
          align='center'
          :label="$t('app_pushTime')"
          width='175'>
        </el-table-column>
        <el-table-column
          align='center'
          prop="distributorName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='center'
          width='110'>
          <template slot-scope='scope'>
            <!-- <el-button v-show="scope.row.isUpdate === '0'" @click='updateDv(scope.row)' type=text>{{$t('app_update')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_update')" placement="top">
              <el-button type='text' v-show="scope.row.isUpdate === '0'" @click='updateDv(scope.row)'><i class="fa fa-refresh" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-button @click='bindOperate(scope.row)' type=text>{{$t('app_unbind')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_unbind')" placement="top">
              <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-chain-broken" style=""></i></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
      
      <div class="gPgDiv">

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="page"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<style>
  #abBindDv{}
  #abInfo p{height:30px;}
  #abInfo td{height:30px;background:none;}
  #abInfo{background: none;width:50%;border:1px solid #EAEEFA;border-radius:7px;height:105px;display:flex;display:-webkit-flex;overflow:hidden;}
  .diTag{background:no1ne;height:52px;width:50%;display:inline-block;}
    .diTag div{width:93%;height:100%;;background:none;display:flex;display:-webkit-flex;flex-direction:column;overflow:hidden;font-size:14px;color:#495769; text-overflow:ellipsis;white-space:nowrap;}
</style>

<script>
  export default{
    data () {
      return {
        mechanismId: window.localStorage['mechanismId'],
        tableData: [],
        info: '',
        total: 0,
        row: this.$gRow,
        page: 1,
        list: [],
        sNum: 0,
        raw: ''
      }
    },
    components: {},
    computed: {
      avt () {
        // return this.$host + this.info.appSmallIcon
        var url = this.info.appBigIcon ? this.$urls.prefix + this.info.appBigIcon : require('../../assets/df.png')
        return  url
      },
      avtStyle () {
        return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + this.avt + ')'
      },
      index () {
        return this.$getWPage('appMarketPushPage')
      }
    },
    methods: {
      updateDv (row) {
        // console.log(this.info)
        this.loading = 1
        var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', row.terminialId, cId, (res) => {
            this.loading = 0
            this.$message(res.message)
            if (res.status === 200) {
              this.getBinds(this.page)
            }
          }, () => {
            this.loading = 0
          })
        } else {
          this.$bindApp1(this.mechanismId, row.terminalNo, cId, (res) => {
            this.loading = 0
            this.$message(res.message)
            if (res.status === 200) {
              this.getBinds(this.page)
            }
          }, () => {
            this.loading = 0
          })
        }
        
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      handleSelectionChange (list) {
        // console.log(list)
        this.sNum = list.length
        this.list = list
      },
      allUnbind () {
        //alert()
        //return 
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isUnbindApp'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          var ids = ''
          var tNos = ''
          this.list.forEach((vl) => {
            ids += vl.terminialId + ','
            tNos += vl.terminalNo + ','
          })
          ids = ids.substring(0, ids.length - 1)
          tNos = tNos.substring(0, tNos.length - 1)
          // console.log(ids)
          if (!ids && !tNos) {
            this.$message($t('app_oneDeviceMust'))
            return 
          }
          this.unbindReq(ids, this.info.applicationid, tNos, this.info.packagename)
        }, '')
        
      },
      bindOperate (row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isUnbindApp'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          // console.log(this.info.applicationid, row.terminialId)
          this.unbindReq(row.terminialId, this.info.applicationid, row.terminalNo, this.info.packagename)
        }, '')
      },
      unbindReq (tId, aId, tNo, pkg) {
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$bindApp('1', tId, aId, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getBinds(this.page)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
        } else {
         
          this.$unbind(tNo, pkg, (res) => {
            this.loading = 0
            if (res.status === 200) {
              
              this.getBinds(this.page)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
        }
        
      },
      addBind () {
        //this.$router.push({name: this.$t('menu.appManageSub.appBind')})
        console.log(this.info)
        if (this.raw.type === 0) {
          this.$router.push({path: 'terminalbind'})
        } else {
          this.$router.push({path: 'terminal-bind'})
        }
      },
      getBinds (page) {
        this.loading = 1
        if (this.$appUrlTag === 0) {
          var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid
          consolelog('iiif', this.info)
          this.$getAppBindDevices(this.$gRow, 1, this.info.packagename, cId, this.mechanismId,(res) => {
            this.loading = 0
            if (res.status === 200) {
              console.log(res)
              this.tableData = res.data
              this.total = res.total
              this.page = page
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        } else {
          var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid
          this.$getAppBindDevices1(this.$gRow, 1, this.info.packagename, cId, this.mechanismId,(res) => {
            this.loading = 0
            if (res.status === 200) {
              console.log(res)
              this.tableData = res.data
              this.total = res.total
              this.page = page
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        }
        
      },
      pageSelect (index) {
        this.getBinds(index)
        this.$setWPage('appMarketPushPage', index)
      },
      pageSized (val) {
        this.$gRow = val
        this.getBinds(this.index)
      }
    },
    mounted () { 
      var obj = this.$getWObj().appBindInfo
      this.info = obj.data
      this.raw = obj
      this.getBinds(this.page)
    }
  }
</script>



// WEBPACK FOOTER //
// distributePush.vue?57610577